var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M2 8a1.333 1.333 0 1 1 2.667 0A1.333 1.333 0 0 1 2 8m4.667 0a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.666 0m4.666 0A1.333 1.333 0 1 1 14 8a1.333 1.333 0 0 1-2.667 0",
    clipRule: "evenodd"
  })));
};
export default SvgDotsHorizontal;